/**
 * Messages FR des tutorials
 */

module.exports = {

    currentStep: 'Étape { currentStep } / { totalStep }',
    nextStepAltLabel: 'Passer à l\'étape suivante.',

    taskPlanning: {
        addNetwork: {
            title: 'Ajoutez vos réseaux sociaux',
            description: 'Utilisez le bouton "+" pour connecter vos réseaux sociaux afin de publier.',
            nextStepLabel: 'C\'est compris !'
        },
        addLateralMenuTask: {
            title: 'Ajoutez un post',
            description: 'Ajoutez un post via un prompte, une url, une image.',
            nextStepLabel: 'C\'est compris !'
        },
        generatePlanning: {
            title: 'Générez vos posts',
            description: 'Cliquez sur le bouton pour générer vos nouveaux posts.',
            nextStepLabel: 'C\'est compris !'
        },
        /*searching: {
            title: 'Effectuez une recherche',
            description: 'Recherchez un post donné dans la liste des publications.',
            nextStepLabel: 'C\'est compris !'
        },
        filterTasks: {
            title: 'Triez par filtres et statut',
            description: 'Appliquez des filtres ou un statut pour trier vos posts dans la liste.',
            nextStepLabel: 'C\'est compris !'
        },*/
        taskList: {
            title: 'Liste des posts',
            description: 'Retrouvez ici la liste des posts du mois par ordre chronologique.',
            nextStepLabel: 'C\'est compris !'
        },
        /*regenerateTask: {
            title: 'Liste des posts',
            description: 'Regénérez un post en modifiant le sujet et les paramètres IA.',
            nextStepLabel: 'C\'est compris !'
        },
        publicationDateTask: {
            title: 'Liste des posts',
            description: 'Découvrez la date et l\'heure de diffusion préconisée par Tookano.',
            nextStepLabel: 'C\'est compris !'
        },*/
        /***/
        previewVisual: {
            title: 'Votre visuel',
            description: 'Editez et validez le visuel de votre post.',
            nextStepLabel: 'C\'est compris !'
        },
        editVisual: {
            title: 'Editeur graphique',
            description: 'Cliquez pour modifier l\'image et les textes de votre visuel en édition avancée.',
            nextStepLabel: 'C\'est compris !'
        },
        selectVisualCharter: {
            title: 'Modèle graphique',
            description: 'Sélectionnez le modèle graphique de votre choix ou créez les vôtres.',
            nextStepLabel: 'C\'est compris !'
        },
        selectVisual: {
            title: 'Image de fond',
            description: 'Sélectionnez l\'image de fond qui vous convient le mieux. Ouvrez l\'éditeur graphique pour en avoir de nouvelles.',
            nextStepLabel: 'C\'est compris !'
        },

        validVisual: {
            title: 'Votre visuel',
            description: 'Validez le visuel de votre post.',
            nextStepLabel: 'C\'est compris !'
        },
        regenerateVisual: {
            title: 'Votre visuel',
            description: 'Regénérez de nouveaux visuels pour votre post.',
            nextStepLabel: 'C\'est compris !'
        },
        changeHook: {
            title: 'Votre accroche',
            description: 'Modifiez l\'accroche proposée en entrant du texte.',
            nextStepLabel: 'C\'est compris !'
        },
        regenerateHook: {
            title: 'Flèche régénératrice',
            description: 'Régénérez une accroche en modifiant le prompte.',
            nextStepLabel: 'C\'est compris !'
        },
        uploadMedia: {
            title: 'Uploadez votre visuel',
            description: 'Intégrez vos propres visuels pour votre post.',
            nextStepLabel: 'C\'est compris !'
        },
        /***/
        editTaskTitle: {
            title: 'Titre du post',
            description: 'Donnez un titre à votre post pour le retrouver facilement.',
            nextStepLabel: 'C\'est compris !'
        },
        editTaskPublicationDate: {
            title: 'Date et heure du post',
            description: 'Modifiez la date et l\'heure de publication du post.',
            nextStepLabel: 'C\'est compris !'
        },
        publicationPreview: {
            title: 'Prévisualisation',
            description: 'Regardez comment apparaitra votre post sur vos réseaux sociaux.',
            nextStepLabel: 'C\'est compris !'
        },
        removeTask: {
            title: 'Supprimez post',
            description: 'Supprimez l\'intégralité du post.',
            nextStepLabel: 'C\'est compris !'
        },
        regenerateTaskFromTaskDetails: {
            title: 'Régénérez le post',
            description: 'Régénérez l\'intégralité du post (visuel et accroche).',
            nextStepLabel: 'C\'est compris !'
        },
        validTaskFromTaskDetails: {
            title: 'Validez le post',
            description: 'Programmez le post pour diffusion sur les réseaux sociaux sélectionnés aux dates et heures indiquées.',
            nextStepLabel: 'C\'est compris !'
        },
        /***/
        changeDisplayMode: {
            title: 'Mode d\'affichage',
            description: 'Changez le mode d\'affichage de votre planning : vue liste ou vue calendrier.',
            nextStepLabel: 'C\'est compris !'
        },
        addTask: {
            title: 'Ajoutez une publication',
            description: 'Ajoutez votre propre publication ou commandez une publication sur mesure à nos CM (via vos crédits).',
            nextStepLabel: 'C\'est compris !'
        },
        iaSettings: {
            title: 'Paramétrez l\'IA',
            description: 'Modifiez les paramètres génériques pris en compte par l\'IA : fréquence, cible, ton, émojis...',
            nextStepLabel: 'Consulter mon planning'
        }
    }
};
